import { getApiActionTypes } from '../redux_utils';

export const ACTIONS = {
  // GET : /resident/background-check-info
  ...getApiActionTypes('FETCH_RESIDENT_PERSONAL_INFO'),
  // PUT : /residents/background-check-info
  ...getApiActionTypes('UPDATE_LEGAL_IDENTITY'),
};
